module.exports = __webpack_public_path__ + "img/bell-03.59c59244.svg";